import React from 'react';
import styled from 'styled-components';
import TableColumnFilters from '../UsersManagement/components/UsersList/TableColumnFilters';
import { SearchOutlined } from '@ant-design/icons';
import { uniq } from 'lodash';

const WidgetHeader = styled.div`
    width: 100%;
    padding: 7px;
    text-align: center;
    font-weight: bold;
`;

const extractStringFieldUniqValues = (dataToDisplay, field) => {
    if (!dataToDisplay) return [];
    return uniq(dataToDisplay.map((row) => (row[field] || '').toLowerCase()));
};

const makeColumnFilteringProps = (data, field) => ({
    filterDropdown: (props) => <TableColumnFilters {...props} options={extractStringFieldUniqValues(data, field)} />,
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#30B79C' : undefined }} />,
    onFilter: (value, record) =>
        record[field] ? record[field].toString().toLowerCase().includes(value.toLowerCase()) : '',
});

export { WidgetHeader, makeColumnFilteringProps };
